import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { useContext } from 'react';
import useStyles from './PIMBadge.styles';
import { getColorHexCode } from '../../utils/colorMapping';
import { SiteContext } from '../../utils/common';
const VALID_POSITIONS = new Set(['top left', 'top right', 'bottom left', 'bottom right']);
const PIMBadge = ({ pimBadge, isCarousel = false, isFromProductCard = false, isFromProductDetail = false, isFromProductDetailV2 = false, }) => {
    var _a, _b;
    const { isFlyingFlowers = false } = useContext(SiteContext);
    // Determine badge position, falling back to top left when missing or invalid
    const position = VALID_POSITIONS.has(pimBadge === null || pimBadge === void 0 ? void 0 : pimBadge.badgingPosition)
        ? pimBadge === null || pimBadge === void 0 ? void 0 : pimBadge.badgingPosition
        : 'top left';
    const isLeftAligned = position === 'top left' || position === 'bottom left';
    // Map color names to hex codes using the color mapping utility
    const line1ColorResult = getColorHexCode(pimBadge === null || pimBadge === void 0 ? void 0 : pimBadge.badgeColourLine1, isFlyingFlowers);
    const line2ColorResult = getColorHexCode(pimBadge === null || pimBadge === void 0 ? void 0 : pimBadge.badgeColourLine2, isFlyingFlowers);
    const { classes: styleClasses } = useStyles({
        line1BackgroundColor: line1ColorResult.backgroundColor,
        line1TextColor: line1ColorResult.textColor,
        line2BackgroundColor: line2ColorResult.backgroundColor,
        line2TextColor: line2ColorResult.textColor,
        isFromProductCard,
        isFromProductDetail,
        isFromProductDetailV2,
        isLeftAligned,
    });
    // Guard against missing pimBadge
    if (!pimBadge) {
        return null;
    }
    // Convert position format from 'top left' to 'topLeft' for style key lookup
    const normalizePosition = (pos) => {
        if (!pos)
            return 'topLeft';
        const normalized = pos
            .split(' ')
            .map((word, idx) => (idx === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
            .join('');
        return normalized;
    };
    const stylePosition = normalizePosition(position);
    // Get carousel padding for container
    const getCarouselPaddingClass = (badgePosition) => {
        // Apply padding only in carousel context, but NOT on product card
        const shouldApplyPadding = isCarousel && !isFromProductCard;
        if (!shouldApplyPadding)
            return '';
        const isLeftAlign = badgePosition === 'top left' || badgePosition === 'bottom left';
        return isLeftAlign ? styleClasses.carouselPaddingLeft : styleClasses.carouselPaddingRight;
    };
    // Get carousel padding for text lines
    const getTextLinePaddingClass = () => {
        // Apply padding only in carousel context, but NOT on product card
        const shouldApplyPadding = isCarousel && !isFromProductCard;
        if (!shouldApplyPadding)
            return '';
        return isLeftAligned ? styleClasses.carouselPaddingLeft : styleClasses.carouselPaddingRight;
    };
    // Build container classes
    const getContainerClasses = () => {
        const classes = [styleClasses.container, styleClasses[stylePosition], getCarouselPaddingClass(position)];
        return classes.filter(Boolean);
    };
    // Trim badge text and treat whitespace-only strings as not provided
    const badgeTextLine1 = (_a = pimBadge.badgeTextLine1) === null || _a === void 0 ? void 0 : _a.trim();
    const badgeTextLine2 = (_b = pimBadge.badgeTextLine2) === null || _b === void 0 ? void 0 : _b.trim();
    return (_jsx("div", { className: clsx(...getContainerClasses()), children: _jsxs("div", { className: styleClasses.badgeContent, children: [badgeTextLine1 && (_jsx("div", { className: clsx(styleClasses.textLine, styleClasses.textLine1, getTextLinePaddingClass()), children: _jsx("span", { className: styleClasses.textLineContent, children: badgeTextLine1 }) })), badgeTextLine2 && (_jsx("div", { className: clsx(styleClasses.textLine, styleClasses.textLine2, getTextLinePaddingClass()), children: _jsx("span", { className: styleClasses.textLineContent, children: badgeTextLine2 }) }))] }) }));
};
export default PIMBadge;
